import { NgModuleRef, Type } from '@angular/core';
import * as i0 from "@angular/core";
var DynamicOutletRegistryService = /** @class */ (function () {
    function DynamicOutletRegistryService() {
        /**
        * A registry array of Component Name to details
        * that must be updated with each new component
        * that you wish to load dynamically.
        */
        this._registry = new Map();
        this._modules = new Map();
    }
    DynamicOutletRegistryService.prototype.register = function (id, values, moduleRef) {
        // ensure module is registered only once.
        var _this = this;
        if (!this._modules.has(id)) {
            console.log('Registering Module components', id);
            this._modules.set(id, values);
        }
        values.forEach(function (p) {
            if (moduleRef != null) {
                p.module = p.module || moduleRef;
            }
            _this._registry.set(p.componentName, p);
        });
    };
    DynamicOutletRegistryService.prototype.get = function (componentName) {
        var registryItem = this._registry.get(componentName);
        return registryItem;
    };
    DynamicOutletRegistryService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DynamicOutletRegistryService_Factory() { return new DynamicOutletRegistryService(); }, token: DynamicOutletRegistryService, providedIn: "root" });
    return DynamicOutletRegistryService;
}());
export { DynamicOutletRegistryService };
